// extracted by mini-css-extract-plugin
export var brand = "_ap-9";
export var compact = "_ap-6";
export var extraSmall = "_ap-7";
export var icon = "_ap-0";
export var large = "_ap-4";
export var light = "_ap-1";
export var medium = "_ap-5";
export var outline = "_ap-b";
export var primaryDark = "_ap-a";
export var primaryLight = "_ap-8";
export var primaryModern = "_ap-c";
export var success = "_ap-2";
export var successSolid = "_ap-3";